import { SIMPLE_CITATION_REGEX } from "../../../constants";

export function wrapConsecutiveCitations(htmlString: string, qid: string) {
  const citationRegex = SIMPLE_CITATION_REGEX;

  // Helper function to wrap citations
  function wrapCitations(text: string) {
    const tokens = text.split(/(\[\d+\.\d+\]|,\s*|\s+)/);
    const result = [];
    let buffer = [];
    let citationCount = 0;

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      if (citationRegex.test(token)) {
        buffer.push(token.slice(1, -1)); // Remove square brackets
        citationCount++;
      } else if (
        (token.trim() === "" || token.trim() === ",") &&
        (citationCount > 0 || buffer.length > 0)
      ) {
        // Skip adding separators to buffer
      } else {
        if (citationCount >= 3) {
          // result.push(`{{${buffer.join(", ")}}}`);
          result.push(
            `<multipleCitations citationString="${buffer.join(", ")}" qid="${qid}"></multipleCitations>`
          );
        } else {
          result.push(...buffer.map((citation) => `[${citation}]`));
        }
        result.push(token);
        buffer = [];
        citationCount = 0;
      }
    }

    if (citationCount >= 3) {
      // result.push(`{{${buffer.join(", ")}}}`);
      result.push(
        `<multipleCitations citationString="${buffer.join(", ")}" qid="${qid}"></multipleCitations>`
      );
    } else {
      result.push(...buffer.map((citation) => `[${citation}]`));
    }

    return result.join("");
  }

  // Process the HTML string
  return htmlString.replace(/>([^<]+)</g, (match, p1) => {
    if (citationRegex.test(p1)) {
      return `>${wrapCitations(p1)}<`;
    }
    return match;
  });
}
